import Vue from 'vue'
import NotiInline from './NotiInline.vue'

const defaults = {
  title: null,
  subTitle: '',
  type: '',
  visibleInline: true
};

const MtNotiInlineConstructor = Vue.extend(NotiInline)
const initInstance = () => {
  instance = new MtNotiInlineConstructor({
    el: document.createElement('div')
  });
}

let currentMessage, instance
let messageQueue = []

const showNextMessage = () => {

  if (!instance) {
    initInstance()
  }
  instance.action = ''

  if (!instance.visible) {
    if (messageQueue.length > 0) {
      currentMessage = messageQueue.shift()

      let options = currentMessage.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visibleInline = true
      });
    }
  }
}

const MtNotiInline = function(options) {
  messageQueue.push({
    options: Object.assign({}, defaults, options),
  });

  showNextMessage()
}

MtNotiInline.inline = (title, subTitle, options) => {
  return MtNotiInline( Object.assign({}, {
    title: title,
    subTitle: subTitle,
  }, options));
};

export default MtNotiInline



// WEBPACK FOOTER //
// ./src/plugins/mtui/noti-inline/index.js